module.exports = __webpack_public_path__ + "/img/e692d6b9c4875901f316a2a3048209bb.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/client/assets/appimg/profile-icon.png
 ** module id = 16
 ** module chunks = 0 4 5
 **/